'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _events = require('./events');

var _fireOperationalEvent = require('./fire-operational-event');

var _fireScreenEvent = require('./fire-screen-event');

var _fireTrackEvent = require('./fire-track-event');

var _fireUiEvent = require('./fire-ui-event');

// data.type necessary cause of flow
exports.default = function (data) {
    if (!data) {
        throw new Error('No event data passed in');
    }

    if (data.client && data.type !== _events.OPERATIONAL_EVENT_TYPE) {
        throw new Error('Sending events via client is not supported in non Operational events');
    }

    if (data.type === _events.UI_EVENT_TYPE) {
        (0, _fireUiEvent.fireAnalyticsUiEvent)(data.analyticsEvent, data.payload);
    } else if (data.type === _events.TRACK_EVENT_TYPE) {
        (0, _fireTrackEvent.fireAnalyticsTrackEvent)(data.analyticsEvent, data.payload);
    } else if (data.type === _events.OPERATIONAL_EVENT_TYPE) {
        (0, _fireOperationalEvent.fireAnalyticsOperationalEvent)(data);
    } else if (data.type === _events.SCREEN_EVENT_TYPE) {
        (0, _fireScreenEvent.fireAnalyticsScreenEvent)(data.analyticsEvent, data.payload);
    } else {
        throw new Error('Event type not supported: ' + data.type);
    }
};